export default __webpack_public_path__ + "static/small-image-richinstead-3-c4cf649e3b0bb39d369550ebbabfce1a.png";